import React, { useState } from "react";
import styled from "styled-components/macro";
import rent from "../../../images/unit/wizard/rent.svg";
import ride from "../../../images/unit/wizard/ride.svg";
import shop from "../../../images/unit/wizard/shop.svg";
import printer from "../../../images/unit/wizard/print.svg";
import rentChosen from "../../../images/unit/wizard/rent-chosen.svg";
import rideChosen from "../../../images/unit/wizard/ride-chosen.svg";
import shopChosen from "../../../images/unit/wizard/shop-chosen.svg";
import printerChosen from "../../../images/unit/wizard/print-chosen.svg";
import info from "../../../images/unit/wizard/info.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { StyledBlackButton } from "../../ButtonsStyle";
import { Popup } from "semantic-ui-react";

const WizardUnitStep5 = ({ onClick, onBackPress, productsType }) => {
  const properties = [
    {
      title: "Rentals",
      key: "rentals",
      image: rent,
      chosen: rentChosen,
      hint: "High quality, on-demand products for the use of tenants.\nIncludes all add-ons, manuals, and insurance",
    },
    {
      title: "Ride",
      key: "ride",
      image: ride,
      chosen: rideChosen,
      hint: "In-house micro-mobility charging station that includes scooters, bikes, and e-bikes for tenant's convenience",
    },
    {
      title: "Shop",
      key: "shop",
      image: shop,
      chosen: shopChosen,
      hint: "Essentials, cleaning supplies, and more for purchase 24/7 in your building",
    },
    {
      title: "Printer",
      key: "printer",
      image: printer,
      chosen: printerChosen,
      hint: "Easy-to-use printer interface that allows direct printing from the application. Documents available to pick up at printer station",
    },
  ];

  const [property, setProperty] = useState(
    productsType
      ? productsType.map((item) =>
          properties?.findIndex((e) => e.title === item.title)
        )
      : []
  );

  const _renderProperties = () => {
    return properties.map((item, index) => {
      return (
        <Section
          index={index}
          className={`animate__animated animate__fadeIn`}
          onClick={() => {
            let list = [...property];
            if (!property.includes(index)) {
              list.push(index);
            } else {
              const propertyIndex = property.findIndex((e) => e === index);
              list.splice(propertyIndex, 1);
            }

            setProperty(list);
          }}
          key={item.title}
        >
          <img
            height={150}
            src={property.includes(index) ? item.chosen : item.image}
            alt={"residential"}
          />
          <div style={{ display: "flex", position: "relative" }}>
            <Title style={{ marginTop: "5px" }} fontSize={20}>
              {item.title.toUpperCase()}
            </Title>
            <Popup
              position="bottom left"
              trigger={
                <div
                  style={{
                    position: "absolute",
                    top: -5,
                    right: -35,
                    padding: "10px",
                  }}
                >
                  <img src={info} alt="info" />
                </div>
              }
              flowing
            >
              <PopUpText>{item.hint}</PopUpText>
            </Popup>
          </div>
          <Radio>
            {property.includes(index) && (
              <FontAwesomeIcon color={"#13647b"} icon={faCheck} />
            )}
          </Radio>
        </Section>
      );
    });
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <div
          onClick={onBackPress}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          <FontAwesomeIcon size={"lg"} color={"#4b4b4b"} icon={faArrowLeft} />
        </div>
        <Title fontSize={35}>What should we include in your TULU?</Title>
      </TitleWrapper>
      <ImagesWrapper>{_renderProperties()}</ImagesWrapper>

      <StyledBlackButton
        disabled={property.length === 0}
        onClick={() => onClick(property.map((i) => properties[i]))}
        style={{
          marginTop: "40px",
          backgroundColor: property.length === 0 ? "#a1a0a0" : "#606060",
          color: "#FFFFFF",
          fontSize: "20px",
          fontFamily: " Manrope,serif",
          padding: "10px 40px",
        }}
      >
        Next
      </StyledBlackButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const PopUpText = styled.div`
  align-items: center;
  white-space: pre-wrap;
  justify-content: center;
  position: relative;
  display: flex;
  color: #4b4b4b;
  font-size: 14px;
  line-height: 1.6;
  flex-direction: column;
  font-family: Manrope, serif;
  padding: 10px;
  box-shadow: 2px 2px 5px #bababa;
  background-color: white;
  border-radius: 10px;
  max-width: 15vw;
`;

const Radio = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  width: 22px;
  height: 22px;
  border-radius: 2px;
  padding: 4px;
  border: 1px solid #13647b;
`;

const Section = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  animation-delay: ${({ index }) => 60 * index}ms;
  width: 300px;
`;

const ImagesWrapper = styled.div`
  align-items: start;
  justify-content: center;
  position: relative;
  flex-direction: row;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 100px;
`;

const Title = styled.div`
  padding: 10px 0;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;
export { WizardUnitStep5 };
